/**
 * axios setup to use mock service
 */

import axios from "axios";
import { forceAdminSessionTimeout } from "./adminSession";

const axiosServices = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://api.smart-typing.com/api",
  timeout: 15000,
});

axiosServices.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem("serviceToken");
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// interceptor for http
axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const hasSession = Boolean(window.localStorage.getItem("serviceToken"));

    if (hasSession && (status === 401 || status === 403)) {
      forceAdminSessionTimeout();
    }

    return Promise.reject(
      (error.response && error.response.data) || {
        message: "Unable to reach SmartTyping services",
      },
    );
  },
);

export default axiosServices;
